import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_USER_INFO } from '../../../api/gql';
import QuestionTable from './questionTable/QuestionTable';
import { IInitialInfo, IUserInfoInput } from '../../../models/UserInfo.interface';
import api from '../../../api/ajax';
import { ENUM_API_TYPE, ENUM_ENDPOINT } from '../../../enum/API';
import { useInput } from '../../../utiles/utiles';
import Alert from '../../alert/Alert';
import { useTranslation, Trans } from "react-i18next";

const Dialog = (props: { setQuestionDialog: React.Dispatch<React.SetStateAction<boolean>> }): JSX.Element | null => {
    const { t } = useTranslation();
    const { data, loading } = useQuery<IInitialInfo>(GET_USER_INFO);
    const [agree, setAgree] = useState(false);
    const [comment, setComment] = useState('');
    const [alert, setAlert] = useState({
        email: '',
        isSuccessed: false,
        open: false,
    });
    const userInfoInput: IUserInfoInput = {
        name: useInput(''),
        email: useInput(''),
        phone: useInput(''),
        companyName: useInput(''),
    };

    let flag = true;

    // 렌더는 시키지 않고
    let isNext: boolean = false;

    //바디 스크롤을 막는다
    useEffect(() => {
        document.body.setAttribute('style', 'overflow:hidden');
        return () => document.body.setAttribute('style', 'overflow:auto');
    }, []);

    const onSend = () => {
        const formData = new FormData();

        if (isNext && flag) {
            flag = false;
            const email: string = data ? data.userInfo.email : userInfoInput.email.value; // email 중복 사용 하기에 변수에 저장
            formData.append('name', data ? data.userInfo.name : userInfoInput.name.value);
            formData.append('email', email);
            formData.append('phone', data ? data.userInfo.phone : userInfoInput.phone.value);
            formData.append('companyName', data ? data.userInfo.companyName : userInfoInput.companyName.value);
            formData.append('ticket_type', '900000107526');
            formData.append('comment', comment);

            api(ENUM_API_TYPE.POST)
                .post(ENUM_ENDPOINT.ENROLLTICKET, formData)
                .then(async result => {
                    const resultData = await result.json();
                    setAlert({
                        email,
                        isSuccessed: resultData.resultCode === 201 ? true : false,
                        open: true,
                    });
                    flag = resultData.resultCode === 201 ? true : false;
                });
        }
    };

    if (loading) return null;

    if (agree && comment.trim() !== '') {
        isNext = true;
    }

    return (
        <>
            <div className="LUX_basic_dialog">
                <div className="dimmed"></div>
                <div className="dialog_wrap_tbl">
                    <div className="dialog_wrap_tblcel">
                        <div className="dialog_wrap">
                            <div className="dialog_content sm">
                                <div className="dialog_data">
                                    <div className="dialog_data_tit">
                                        <h1>{t("enquiryRegistration")}</h1>
                                        <button
                                            type="button"
                                            className="LUX_basic_btn btn_clr"
                                            onClick={() => {
                                                props.setQuestionDialog(false);
                                            }}
                                        >
                                            <span className="sp_lux">닫기</span>
                                        </button>
                                    </div>
                                    <div className="dialog_data_area">
                                        <p className="title_desc">
                                            {t("enquirySubText")}
                                        </p>
                                        <div className="LUX_basic_tbl">
                                            <div className="tbl_tit">
                                                <h2>{t("InquirerInfo")}</h2>
                                            </div>
                                            <QuestionTable userInfo={data?.userInfo} userInfoInput={userInfoInput} />
                                        </div>
                                        <div className="LUX_basic_tbl" style={{ marginTop: '20px' }}>
                                            <div className="tbl_tit">
                                                <h2>{t("InquirerContent")}</h2>
                                            </div>
                                            <table className="tblarea2">
                                                <caption>
                                                    <span className="blind"></span>
                                                </caption>
                                                <colgroup>
                                                    <col style={{ width: '150px' }}></col>
                                                </colgroup>
                                                <tbody>
                                                    <tr>
                                                        <th className="txtlft" scope="row">
                                                            <div className="inbx">{t("InquirerContent")}</div>
                                                        </th>
                                                        <td>
                                                            <div className="inbx">
                                                                <div className="LUX_basic_textarea">
                                                                    <div className="inpbx">
                                                                        <textarea
                                                                            id="undefined-HintText1"
                                                                            rows={5}
                                                                            cols={1}
                                                                            style={{ width: '100%', height: '150px' }}
                                                                            placeholder={t("enterContent")}
                                                                            value={comment}
                                                                            onChange={e => setComment(e.target.value)}
                                                                        ></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div
                                            className="LS_Accordion_TOS typeSingle"
                                            style={{ marginTop: '20px', paddingTop: 0 }}
                                        >
                                            <div className="LS_tosItem open">
                                                <div className="itemHeader">
                                                    <strong className="text">
                                                        {t("usePersonalInfo")}{' '}
                                                        <span className="required">{t("essential")}</span>
                                                        {/* <a
                                                            href="#/"
                                                            target="_blank"
                                                            className="btn_allcontents"
                                                            title="새창열림"
                                                        >
                                                            <span>전문보기</span>
                                                        </a> */}
                                                    </strong>
                                                    <div className={agree ? 'LS_form checked' : 'LS_form'}>
                                                        <label>
                                                            <input
                                                                className="LSinput"
                                                                type="checkbox"
                                                                name="test_check"
                                                                title="동의"
                                                            />
                                                            <span
                                                                className="icon"
                                                                onClick={() => setAgree(v => !v)}
                                                            ></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="itemContent">
                                                    <p>
                                                        {<Trans i18nKey="consentText" />}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="dialog_btnbx">
                                <div>
                                    <button
                                        className="LUX_basic_btn Confirm basic2"
                                        onClick={onSend}
                                        style={
                                            isNext
                                                ? {}
                                                : { background: '#dbdbdb', borderColor: '#dbdbdb', cursor: 'unset' }
                                        }
                                    >
                                        <span>{t("registration")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {alert.open && (
                <Alert
                    email={alert.email}
                    isSuccessed={alert.isSuccessed}
                    setQuestionDialog={props.setQuestionDialog}
                    setAlert={setAlert}
                />
            )}
        </>
    );
};

export default Dialog;
